import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LogOut } from 'lucide-react';

import DashboardTab from './tabs/DashboardTab';
import SuppliersTab from './tabs/SuppliersTab';
import RawMaterialsTab from './tabs/RawMaterialsTab';
import ProductionTab from './tabs/ProductionTab';
import InventoryTab from './tabs/InventoryTab';
import SalesTab from './tabs/SalesTab';

const TABS = [
  { key: 'dashboard',     label: '📊 Dashboard' },
  { key: 'suppliers',     label: '🏭 Suppliers' },
  { key: 'rawMaterials',  label: '🎞️ Raw Materials' },
  { key: 'production',    label: '⚙️ Production' },
  { key: 'inventory',     label: '📦 Inventory' },
  { key: 'sales',         label: '💰 Sales' },
];

const AdhesiveDashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('dashboard');

  const isBusinessman = user?.role === 'businessman';

  const renderTab = () => {
    switch (activeTab) {
      case 'dashboard':    return <DashboardTab />;
      case 'suppliers':    return <SuppliersTab />;
      case 'rawMaterials': return <RawMaterialsTab />;
      case 'production':   return <ProductionTab />;
      case 'inventory':    return <InventoryTab />;
      case 'sales':        return <SalesTab />;
      default:             return <DashboardTab />;
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fa', fontFamily: "'Inter', sans-serif" }}>

      {/* ── TOP HEADER ── */}
      <div style={{
        background: 'linear-gradient(135deg, #f39c12 0%, #e67e22 100%)',
        color: 'white',
        padding: '24px 40px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        flexWrap: 'wrap',
        gap: '16px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
          {isBusinessman && (
            <button
              onClick={() => navigate('/dashboard')}
              style={{
                padding: '10px 20px',
                background: 'rgba(255,255,255,0.2)',
                border: '1px solid rgba(255,255,255,0.3)',
                borderRadius: '8px',
                color: 'white',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '600'
              }}
            >
              ← Back
            </button>
          )}
          <h1 style={{ fontSize: '28px', margin: 0, fontWeight: '700', display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span style={{ fontSize: '32px' }}>📦</span>
            Adhesive Tapes Business
          </h1>
        </div>

        {/* Username + Logout */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{
            padding: '10px 16px',
            background: 'rgba(255,255,255,0.15)',
            border: '1px solid rgba(255,255,255,0.3)',
            borderRadius: '10px',
            fontSize: '14px',
            fontWeight: '600'
          }}>
            👤 {user?.full_name || user?.username || 'User'}
          </div>
          <button
            onClick={logout}
            style={{
              padding: '12px 24px',
              background: 'rgba(255,255,255,0.2)',
              border: '1px solid rgba(255,255,255,0.3)',
              borderRadius: '10px',
              color: 'white',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontSize: '14px',
              fontWeight: '600'
            }}
          >
            <LogOut size={18} />
            Logout
          </button>
        </div>
      </div>

      {/* ── TAB NAVIGATION ── */}
      <div style={{
        background: 'white',
        borderBottom: '2px solid #f0f0f0',
        padding: '0 40px',
        display: 'flex',
        gap: '4px',
        overflowX: 'auto'
      }}>
        {TABS.map(tab => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={{
              padding: '16px 20px',
              border: 'none',
              borderBottom: activeTab === tab.key ? '3px solid #f39c12' : '3px solid transparent',
              background: 'none',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: activeTab === tab.key ? '700' : '500',
              color: activeTab === tab.key ? '#f39c12' : '#7f8c8d',
              whiteSpace: 'nowrap',
              transition: 'all 0.2s'
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* ── TAB CONTENT ── */}
      <div style={{ padding: '32px 40px' }}>
        {renderTab()}
      </div>

    </div>
  );
};

export default AdhesiveDashboard;